import { DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ShadeFinderStateModule } from "@hermes/states/shade-finder";

import { ShadeFinderModalService } from "./shade-finder-modal.service";

@NgModule({
    imports: [CommonModule, DialogModule, ShadeFinderStateModule],
    providers: [ShadeFinderModalService],
})
export class ShadeFinderModalServiceModule {}
